import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const authKey = () => {
  const auth = store.getState().auth;
  return auth?.user?.auth_key;
};

const payloadFor = (values = {}) => {
  const formData = new FormData();
  formData.append("auth_key", authKey());
  formData.append("sale_id", values.sale_id ?? "");
  if (values.appointment_id != null) formData.append("appointment_id", values.appointment_id);
  if (values.reason != null) formData.append("reason", values.reason);
  return formData;
};

/**
 * SOF-329 GAP-03 — invoice deactivation and its audit timeline.
 *
 * Deactivation reverses a completed sale's voucher usage, so the backend owns
 * the decision and derives the salon from the authenticated actor. The client
 * sends only the sale id and an optional reason; it must never send a salon id.
 */
const deactivateInvoice = (values = {}) => {
  const action = "afterlogin/sale/deactivate";
  return axios.post(API_URL + action, payloadFor(values), {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const invoiceActivity = (values = {}) => {
  const action = "afterlogin/sale/activity";
  const formData = payloadFor(values);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const invoiceActivityApiController = {
  deactivateInvoice,
  invoiceActivity,
};

export default invoiceActivityApiController;
